
import Vue from "vue";
import sDialogComponent from "@/services/sDialog/component/sDialog.vue";
import sToastComponent from "@/services/sToast/sToast.vue";
import ProgressBarComponent from "@/services/progressBar/progressBar.vue";
import LoaderMobileComponent from "@/services/loaderMobile/loaderMobile.vue";
import topHeader from "./components/topHeader/topHeader.vue";
import leftMenu from "./components/leftMenu/leftMenu.vue";
import store from "@/store";
export default Vue.extend({
  name: "App",
  components: {
    sDialogComponent,
    sToastComponent,
    ProgressBarComponent,
    LoaderMobileComponent,
    topHeader,
    leftMenu,
  },
  data: () => ({}),
  methods: {},
  mounted() {},
  computed: {
    isLogin() {
      return store.getters.isLoginGet;
    },
    drawer() {
      return store.getters.userNavDataGet;
    },
  },
});
